module.exports = __webpack_public_path__ + "img/friendly-beach.687dd6b9.jpg";